/**
 * Simplified UAE country + emirate-rough outline as cartesian (lon, lat)
 * polylines.
 *
 * Used as a wireframe basemap behind the Geo Activity scatter — cheap,
 * dependency-free, no GeoJSON registration. Hand-traced from a coast +
 * border map; precision is "recognisable as the UAE", not GIS-grade.
 */
export const UAE_COUNTRY_OUTLINE: Array<[number, number]> = [
  // West coast (Saudi border) heading east along the Arabian Gulf coast
  [51.55, 24.30],
  [51.78, 24.45],
  [52.20, 24.55],
  [52.65, 24.50],
  [53.10, 24.30],
  [53.55, 24.20],
  [53.98, 24.15],
  [54.40, 24.45],
  [54.62, 24.50],
  [54.95, 24.85],
  [55.10, 25.10],
  [55.27, 25.27],
  [55.45, 25.40],
  [55.55, 25.55],
  [55.85, 25.78],
  // Northern tip → Musandam exclave gap (we elide the Oman gap)
  [56.05, 25.95],
  [56.40, 25.78],
  // East coast heading south
  [56.42, 25.40],
  [56.35, 25.15],
  [56.28, 25.00],
  [56.20, 24.85],
  [56.05, 24.55],
  [55.85, 24.20],
  // South border (Saudi / Oman) heading west
  [55.40, 23.50],
  [55.05, 23.05],
  [54.50, 22.65],
  [53.90, 22.60],
  [53.20, 22.65],
  [52.55, 22.85],
  [51.90, 23.40],
  [51.65, 23.85],
  // Close
  [51.55, 24.30],
];

/**
 * Major-city anchor points for label placement on the wireframe map.
 * These don't draw a boundary — just give the user a sense of scale.
 */
export const UAE_CITY_ANCHORS: Array<{ name: string; lon: number; lat: number }> = [
  { name: "Abu Dhabi", lon: 54.37, lat: 24.47 },
  { name: "Dubai", lon: 55.27, lat: 25.20 },
  { name: "Sharjah", lon: 55.41, lat: 25.36 },
  { name: "Ajman", lon: 55.55, lat: 25.40 },
  { name: "RAK", lon: 55.95, lat: 25.79 },
  { name: "Fujairah", lon: 56.34, lat: 25.13 },
  { name: "Al Ain", lon: 55.74, lat: 24.20 },
];
